import requestCache from '@/utils/httpCache';
// import sObserver from '@/utils/simpleObserver';
import axios from 'axios';
import { Loading, Message } from 'element-ui';
import { getLocalToken, setCookie, delToken } from './token';
const gData = {
  store: window.sessionStorage,
  loadingInstance: null
};
// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  // dataType: 'json',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});
service.interceptors.response.use(
  (response) => {
    const res = response.data;
    gData.loadingInstance?.close();
    // const code = res.code;
    // if (+code === 20100 || +code === 20200) {
    //   sObserver.fire('laoshibang-login');
    // }
    if (res.code === 20200) {
      delToken();
      window.location.reload();
    } else if (res.code === 20100 || res.code === 11100) {
      delToken();
    }
    return res;
  },
  async (error) => {
    gData.loadingInstance?.close();
    const config = error.config;
    // 判断是否为超时错误
    const isTimeout = error.message && error.message.includes('timeout');
    // 设置最大重试次数，默认2次
    config._retryCount = config._retryCount || 0;
    const maxRetry = typeof config.maxRetry === 'number' ? config.maxRetry : 2;
    if (isTimeout && config._retryCount < maxRetry) {
      config._retryCount += 1;
      // 可选：可在此处添加延迟重试逻辑
      return service(config);
    }
    if (error.response?.status !== 200 || isTimeout) {
      Message.error('网络异常，暂无数据');
    }
    return Promise.reject(error);
  }
);
service.interceptors.request.use((config) => {
  window.TAL_UC.getDeviceInfo({
    success: (res) => {
      const deviceId = res.data['device-id'] || '';
      sessionStorage.setItem('X-Device-Id', deviceId);
      setCookie('X-Device-Id', deviceId, 300);
    },
    fail: (error) => {
      console.error(error);
    }
  });
  config.headers['X-Client-Id'] = 1031102;
  config.headers['X-Device-Id'] = getLocalToken('TALDeviceId');
  config.headers['X-Version-Num'] = '1';
  config.headers['X-Client-Token'] = getLocalToken('tal_token');
  if (config.isLoading) {
    gData.loadingInstance = Loading.service({
      lock: true,
      text: '加载中',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0)',
      customClass: 'loadingCon'
    });
  }
  return config;
});

// 启用http缓存
const cacheService = requestCache(service, false);

// 不同接口状态测试代码 - 配合 vue.config.js 使用
// if (process.env.NODE_ENV === 'development') {
//   // 本地测试不同状态码的接口
//   function testMockStatusApi(status) {
//     service.get(`/mock/test${status}`)
//       .then(res => {
//         // 正常不会走到这里
//         console.log(`接口 /mock/test${status} 正常返回:`, res);
//       })
//       .catch(err => {
//         // 这里会捕获到 500/501/503 错误
//         console.error(`接口 /mock/test${status} 错误:`, err);
//       });
//   }

//   // 依次测试 500、501、503
//   [500, 501, 503].forEach(testMockStatusApi);
// }

export default cacheService;
